module.exports = __webpack_public_path__ + "static/logo-610740e8b7dcd80e53d7341099f0b497.svg";